// src/components/Sidebar.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const SectionCard = ({ children, colour }) => (
  <li
    className={`mb-8 rounded-lg border-l-4 ${colour} bg-gray-800/60 p-4 shadow`}
  >
    {children}
  </li>
);

const H3 = ({ children }) => (
  <h3 className="uppercase tracking-wider text-gray-200 mb-3">{children}</h3>
);

const Item = ({ to, label }) => (
  <li>
    <Link to={to} className="block px-2 py-1 rounded hover:bg-gray-700 text-lg">
      {label}
    </Link>
  </li>
);

const SubItem = ({ to, label }) => (
  <li>
    <Link
      to={to}
      className="block px-2 py-1 rounded hover:bg-gray-700 text-sm ml-4"
    >
      {label}
    </Link>
  </li>
);

function Sidebar() {
  const { logout } = useAuth();

  return (
    <aside className="w-64 h-screen bg-joule text-white p-6 flex flex-col fixed overflow-y-auto">
      {/* logo */}
      <img
        src={process.env.PUBLIC_URL + "/pictures/joule_logo.png"}
        alt="logo"
        className="w-4/5 mx-auto my-8"
      />

      <nav className="flex-1">
        <ul>
          {/* ───── Dashboard ───── */}
          <SectionCard colour="border-l-joule">
            <H3>Dashboard</H3>
            <ul>
              <Item to="/dashboard" label="Dashboard" />
            </ul>
          </SectionCard>

          {/* ───── Subscription ───── */}
          <SectionCard colour="border-l-yellow-400">
            <H3>Subscription</H3>
            <ul className="space-y-2">
              {/* inventory */}
              <Item to="/inventory" label="Inventory" />
              <SubItem to="/service-parts" label="Service Parts" />

              {/* todo list */}
              <Item to="/todo-list" label="To‑Do List" />
              <SubItem to="/new-orders" label="Orders" />
              <SubItem to="/service-bookings" label="Service Bookings" />
              <SubItem to="/returns" label="Returns" />
              <SubItem to="/customer-cases" label="Customer Cases" />
              <SubItem to="/order-picking-list" label="Order Picking" />

              {/* bike flow */}
              <Item to="/bike-flow-dashboard" label="Daily Bike Flow" />
              <SubItem to="/incoming-bikes" label="Incoming Bikes" />
              <SubItem to="/outgoing-bikes" label="Outgoing Bikes" />
              <SubItem to="/transport-booking" label="Transport Booking" />
            </ul>
          </SectionCard>

          {/* ───── External service ───── */}
          <SectionCard colour="border-l-green-400">
            <H3>External Service</H3>
            <ul className="space-y-2">
              <Item to="/external-service/bookings" label="Service Bookings" />
              <Item to="/external-service/todo-list" label="To‑Do List" />
              <Item to="/external-service/bike-flow" label="Bike Flow" />
            </ul>
          </SectionCard>
        </ul>
      </nav>

      <button
        onClick={logout}
        className="bg-gray-400 hover:bg-gray-500 text-black py-2 px-4 rounded w-full mt-4"
      >
        Logout
      </button>
    </aside>
  );
}

export default Sidebar;
